import { DownloadIcon, DragDrop, GKButton, Grid2 } from "components";
import { useState } from "react";
import { Controller, useFormContext } from "react-hook-form";

const ImportStep1 = () => {
  const form = useFormContext();

  const [uploadError, setUploadError] = useState<string | null>(null);

  return (
    <Grid2
      size={12}
      display={"flex"}
      alignItems={"center"}
      justifyContent={"center"}
      flexDirection={"column"}
      width={"100%"}
      maxHeight={250}
      px={1}
      overflow={"auto"}
    >
      <Controller
        name="step1.file"
        control={form.control}
        render={({ field }) => (
          <DragDrop
            uploadError={uploadError}
            setUploadError={setUploadError}
            {...field}
            onChange={(e) => {
              field.onChange(e);
            }}
            acceptType={".csv, .pdf,.xlsx"}
            supportName="CSV or PDF or XLSX"
          />
        )}
      />
      <GKButton
        sx={{
          p: 0,
          color: "var(--neutral-500)",
          display: "flex",
          alignItems: "center",
          "&:hover": {
            background: "transparent",
          },
        }}
        href="https://frontend-logo.s3.amazonaws.com/Fees-Historical_Import.xlsx?versionId=MqznVA8XujJtYV2cHNZUuockUU3suPU0"
        target="_blank"
        startIcon={<DownloadIcon width={14} height={14} />}
      >
        Download Sample File
      </GKButton>
    </Grid2>
  );
};

export default ImportStep1;
